module.exports = __webpack_public_path__ + "static/media/rural-roadwater-rescue-interreg-nwe-vertical.1fa75e90.png";